export const enabledCategories = {
  multiselect: ["Make", "Model", "Eligibility", "Payment"],
};

export const SingleSelectFacets = ["Eligibility", "Payment"];
export const SingleSelectDefaultKey = "Any";
